(function(){
  'use strict';

  var roots = document.querySelectorAll('[data-fs-leaderboard]');
  if(!roots.length) return;

  var sdkPromise = null;

  function loadSdk(){
    if(window.supabase && typeof window.supabase.createClient === 'function') return Promise.resolve(window.supabase);
    if(sdkPromise) return sdkPromise;
    sdkPromise = new Promise(function(resolve,reject){
      var existing = document.querySelector('script[data-fs-lb-supabase]');
      if(existing){
        existing.addEventListener('load', function(){ resolve(window.supabase); }, {once:true});
        existing.addEventListener('error', reject, {once:true});
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2.111.0';
      script.async = true;
      script.dataset.fsLbSupabase = '1';
      script.onload = function(){ resolve(window.supabase); };
      script.onerror = function(){ reject(new Error('Could not load FanScore data client.')); };
      document.head.appendChild(script);
    });
    return sdkPromise;
  }

  function esc(value){
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch];
    });
  }

  function num(value){
    var n = Number(value || 0);
    return Number.isFinite(n) ? n.toLocaleString() : '0';
  }

  function init(root){
    var state = {
      type:'individual',
      period:'season',
      scope:'school',
      gameHandle:'',
      user:null,
      summary:null,
      games:[],
      sb:null,
      loading:false
    };

    var $ = function(sel){ return root.querySelector(sel); };
    var $$ = function(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var els = {
      tabs: $$('[data-lb-type]'),
      periods: $$('[data-lb-period]'),
      scopes: $$('[data-lb-scope]'),
      scopeWrap: $('[data-lb-scope-wrap]'),
      gameWrap: $('[data-lb-game-wrap]'),
      game: $('[data-lb-game]'),
      notice: $('[data-lb-notice]'),
      me: $('[data-lb-me]'),
      meName: $('[data-lb-me-name]'),
      meContext: $('[data-lb-me-context]'),
      meRank: $('[data-lb-me-rank]'),
      mePoints: $('[data-lb-me-points]'),
      mePlays: $('[data-lb-me-plays]'),
      boardKicker: $('[data-lb-board-kicker]'),
      boardTitle: $('[data-lb-board-title]'),
      rows: $('[data-lb-rows]'),
      loading: $('[data-lb-loading]'),
      empty: $('[data-lb-empty]'),
      refresh: $('[data-lb-refresh]'),
      breakdown: $('[data-lb-breakdown]'),
      breakdownList: $('[data-lb-breakdown-list]')
    };

    function setNotice(message){
      els.notice.hidden = !message;
      els.notice.textContent = message || '';
    }

    function setLoading(on){
      state.loading = on;
      els.loading.hidden = !on;
      if(on){
        els.rows.hidden = true;
        els.empty.hidden = true;
      }
      els.refresh.disabled = on;
    }

    async function rpc(name,args){
      var res = await state.sb.rpc(name,args || {});
      if(res.error) throw res.error;
      return res.data;
    }

    function syncButtons(){
      els.tabs.forEach(function(btn){ btn.classList.toggle('is-active', btn.dataset.lbType === state.type); });
      els.periods.forEach(function(btn){ btn.classList.toggle('is-active', btn.dataset.lbPeriod === state.period); });
      els.scopes.forEach(function(btn){ btn.classList.toggle('is-active', btn.dataset.lbScope === state.scope); });
      els.scopeWrap.hidden = state.type === 'fanbase';
      els.gameWrap.hidden = state.type !== 'game';

      var periodLabel = state.period === 'today' ? 'Today' : state.period === 'week' ? 'This week' : state.period === 'season' ? 'Season' : 'All-time';
      var typeLabel = state.type === 'individual' ? 'Fans' : state.type === 'crew' ? 'Crews' : state.type === 'fanbase' ? 'Fanbases' : 'Game leaderboard';
      els.boardKicker.textContent = periodLabel + (state.type === 'fanbase' ? ' - National' : ' - ' + (state.scope === 'school' ? 'My Team' : 'National'));
      els.boardTitle.textContent = state.type === 'game' && state.gameHandle
        ? ((state.games.find(function(g){ return g.game_handle === state.gameHandle; }) || {}).game_name || typeLabel)
        : typeLabel;
    }

    function renderMe(){
      var s = state.summary || {};
      if(!state.user){
        els.meName.textContent = 'Sign in to see your standing';
        els.meContext.textContent = 'Leaderboards can still be viewed below.';
        els.meRank.textContent = '--';
        els.mePoints.textContent = '--';
        els.mePlays.textContent = '--';
        return;
      }
      var rank = state.scope === 'school' ? s.school_rank : s.national_rank;
      els.meName.textContent = 'Your FanScore';
      els.meContext.textContent = (s.school_name || 'FanScore') + ' - ' + (state.period === 'lifetime' ? 'All-Time' : state.period === 'week' ? 'This Week' : state.period === 'today' ? 'Today' : 'Season');
      els.meRank.textContent = rank ? '#' + num(rank) : '--';
      els.mePoints.textContent = num(s.points);
      els.mePlays.textContent = num(s.plays_count);
    }

    function rowMarkup(row,index){
      var rank = row.rank || index + 1;
      var name = '';
      var detail = '';
      var score = 0;
      var scoreLabel = 'FanScore';
      var userId = row.user_id || '';

      if(state.type === 'individual'){
        name = row.display_name || 'Fan';
        detail = row.school_name || 'National';
        score = row.points;
        scoreLabel = (row.plays_count || 0) + ' plays';
      }else if(state.type === 'crew'){
        name = row.crew_name || 'Crew';
        detail = (row.school_name || 'National') + ' - ' + num(row.active_members) + ' active';
        score = row.competition_score;
        scoreLabel = 'Competition score';
      }else if(state.type === 'fanbase'){
        name = row.school_name || 'Fanbase';
        detail = [row.conference_name,row.subdivision].filter(Boolean).join(' - ') || 'College football';
        score = row.competition_score;
        scoreLabel = num(row.active_fans) + ' active fans';
      }else{
        name = row.display_name || 'Fan';
        detail = row.school_name || 'National';
        score = row.fanscore_points;
        scoreLabel = num(row.plays_count) + ' plays';
      }

      var isYou = state.user && userId && userId === state.user.id;
      return '<div class="fs-lb__row' + (isYou ? ' is-you' : '') + '">' +
        '<div class="fs-lb__rank">' + esc(rank) + '</div>' +
        '<div class="fs-lb__who"><strong>' + esc(name) + (isYou ? ' (You)' : '') + '</strong><span>' + esc(detail) + '</span></div>' +
        '<div class="fs-lb__score"><strong>' + esc(num(score)) + '</strong><span>' + esc(scoreLabel) + '</span></div>' +
      '</div>';
    }

    function renderRows(rows){
      rows = Array.isArray(rows) ? rows : [];
      els.rows.innerHTML = rows.map(rowMarkup).join('');
      els.rows.hidden = rows.length === 0;
      els.empty.hidden = rows.length !== 0;
    }

    async function loadSummary(){
      if(!state.user){ state.summary = null; renderMe(); return; }
      try{
        state.summary = await rpc('fs_my_period_summary',{p_period:state.period,p_season_key:null});
        renderMe();
      }catch(err){
        console.warn('FanScore summary:',err);
        state.summary = null;
        renderMe();
      }
    }

    async function loadBreakdown(){
      if(!state.user){
        els.breakdownList.innerHTML = '<div class="fs-lb__empty">Sign in and play a FanScore game to see your breakdown.</div>';
        return;
      }
      try{
        var rows = await rpc('fs_my_game_breakdown',{p_period:state.period,p_season_key:null});
        rows = Array.isArray(rows) ? rows : [];
        if(!rows.length){
          els.breakdownList.innerHTML = '<div class="fs-lb__empty">No game points in this period yet.</div>';
          return;
        }
        els.breakdownList.innerHTML = rows.map(function(row){
          return '<div class="fs-lb__breakdown-item">' +
            '<div><strong>' + esc(row.game_name || row.game_handle || 'Game') + '</strong><span>' + esc(num(row.plays_count)) + ' plays' + (row.best_raw_score != null ? ' - Best raw score ' + esc(num(row.best_raw_score)) : '') + '</span></div>' +
            '<div class="fs-lb__breakdown-points">' + esc(num(row.fanscore_points)) + '</div>' +
          '</div>';
        }).join('');
      }catch(err){
        console.warn('FanScore breakdown:',err);
        els.breakdownList.innerHTML = '<div class="fs-lb__empty">Breakdown is temporarily unavailable.</div>';
      }
    }

    async function loadGames(){
      try{
        var games = await rpc('fs_competition_game_catalog',{});
        state.games = Array.isArray(games) ? games : [];
        els.game.innerHTML = state.games.map(function(g){
          return '<option value="' + esc(g.game_handle) + '">' + esc(g.game_name) + '</option>';
        }).join('');
        if(!state.gameHandle && state.games[0]) state.gameHandle = state.games[0].game_handle;
        els.game.value = state.gameHandle || '';
      }catch(err){
        console.warn('FanScore games:',err);
      }
    }

    async function loadBoard(){
      setLoading(true);
      setNotice('');
      syncButtons();
      try{
        var schoolId = state.scope === 'school' && state.summary ? state.summary.school_id : null;
        var rows;
        if(state.type === 'individual'){
          rows = await rpc('fs_competition_individual_leaderboard',{
            p_period:state.period,p_school_id:schoolId,p_season_key:null,p_limit:50,p_offset:0
          });
        }else if(state.type === 'crew'){
          rows = await rpc('fs_competition_crew_leaderboard',{
            p_period:state.period,p_school_id:schoolId,p_season_key:null,p_limit:50,p_offset:0
          });
        }else if(state.type === 'fanbase'){
          rows = await rpc('fs_competition_fanbase_leaderboard',{
            p_period:state.period,p_season_key:null,p_subdivision:null,p_conference:null,p_limit:266,p_offset:0
          });
        }else{
          if(!state.gameHandle) await loadGames();
          if(!state.gameHandle){ rows = []; }
          else{
            rows = await rpc('fs_competition_game_leaderboard',{
              p_game_handle:state.gameHandle,p_period:state.period,p_school_id:schoolId,p_season_key:null,p_limit:50
            });
          }
        }
        renderRows(rows);
      }catch(err){
        console.error('FanScore leaderboard:',err);
        renderRows([]);
        setNotice(err.message || 'Leaderboard could not load.');
      }finally{
        setLoading(false);
      }
    }

    async function refreshAll(){
      await loadSummary();
      syncButtons();
      await Promise.all([loadBoard(),loadBreakdown()]);
    }

    els.tabs.forEach(function(btn){
      btn.addEventListener('click', async function(){
        state.type = btn.dataset.lbType;
        if(state.type === 'fanbase') state.scope = 'national';
        else if(state.scope !== 'school' && state.scope !== 'national') state.scope = 'school';
        if(state.type === 'game' && !state.games.length) await loadGames();
        syncButtons();
        await loadBoard();
      });
    });

    els.periods.forEach(function(btn){
      btn.addEventListener('click', async function(){
        state.period = btn.dataset.lbPeriod;
        syncButtons();
        await refreshAll();
      });
    });

    els.scopes.forEach(function(btn){
      btn.addEventListener('click', async function(){
        state.scope = btn.dataset.lbScope;
        syncButtons();
        renderMe();
        await loadBoard();
      });
    });

    els.game.addEventListener('change', async function(){
      state.gameHandle = els.game.value;
      syncButtons();
      await loadBoard();
    });

    els.refresh.addEventListener('click', refreshAll);

    (async function boot(){
      try{
        var sdk = await loadSdk();
        var url = root.dataset.supabaseUrl;
        var key = root.dataset.supabaseKey;
        state.sb = window.FanScoreSupabaseClient || sdk.createClient(url,key,{
          auth:{persistSession:true,autoRefreshToken:true,detectSessionInUrl:false}
        });
        window.FanScoreSupabaseClient = window.FanScoreSupabaseClient || state.sb;
        var sessionResult = await state.sb.auth.getSession();
        state.user = sessionResult.data && sessionResult.data.session ? sessionResult.data.session.user : null;
        await loadGames();
        await refreshAll();
      }catch(err){
        console.error('FanScore leaderboard boot:',err);
        setLoading(false);
        setNotice(err.message || 'FanScore leaderboards could not start.');
      }
    })();
  }

  roots.forEach(init);
})();
